import { render } from "./ImportProductosRefrigerados.vue?vue&type=template&id=4013b482"
import script from "./ImportProductosRefrigerados.vue?vue&type=script&lang=js"
export * from "./ImportProductosRefrigerados.vue?vue&type=script&lang=js"

import "./ImportProductosRefrigerados.vue?vue&type=style&index=0&id=4013b482&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__